import React, {Component} from 'react';
import './code-github.css';
class CodeGithubComponent extends Component {

    render() {
        return (
            <div className="code-github">
            </div>
        );
    }
}

export default CodeGithubComponent;
